@if (model$ | async) {
    <div>
        <h1 class="mb-2">
            Site
            @if (model.currentSite) {
                <span>-</span>
            }
            {{ model.currentSite }}
        </h1>
        <hr />
        @if (isExpired) {
            <p class="alert alert-danger text-center">
                24 hours have passed and this link is now expired. You cannot complete or edit this Inventory Count.
            </p>
        }
        @if (canEdit) {
            <p class="alert alert-danger text-center">This inventory count can be edited until the end of the day.</p>
        }
        <div class="inventory-count-head">
            <h4>Inventory Count for {{ model.eventDateStr }}</h4>
            <p>
                Inventory Count will not be run on
                <span class="underline-blue" (click)="openSiteHolidayModal()">holidays</span>.
            </p>
            @if (!canEdit) {
                <div class="row col-md-12 mb-2 readonly-info">
                    <div class="col-md-6">
                        <label class="for">Submitted By</label>
                        {{ model.submissionUserName ? model.submissionDateStr : 'Missing' }}
                    </div>
                    <div class="col-md-6">
                        <label class="for">Date Submitted</label>
                        {{ model.submissionDateStr ? model.submissionDateStr : 'Missing' }}
                    </div>
                </div>
            }
        </div>
        @if (!canEdit) {
            <hr />
        }
        <form
            #form
            (submit)="saveForm()"
            [formGroup]="formGroup"
            (messageSuccess)="saveReturn($event)"
            (messageError)="onMessageError($event)"
        >
            @if (!isExpired) {
                <div class="products-ctnr">
                    @for (o of dailyCounts; track o) {
                        <div class="product-item">
                            <div class="product-header">
                                <h5>
                                    <b>{{ o.name }}</b>
                                </h5>
                            </div>
                            <div class="courses-ctnr">
                                <div class="course-item">
                                    <p>Administered</p>
                                    @if (canEdit) {
                                        <input
                                            [(ngModel)]="o.administered"
                                            [ngModelOptions]="{ standalone: true }"
                                            class="form-control"
                                            pcgNumeric
                                            required
                                            maxlength="7"
                                        />
                                    }
                                    @if (!canEdit) {
                                        <span class="count">{{ o.administered }}</span>
                                    }
                                </div>
                                <div class="course-item">
                                    <p>On Hand</p>
                                    @if (canEdit) {
                                        <input
                                            [(ngModel)]="o.onHand"
                                            [ngModelOptions]="{ standalone: true }"
                                            class="form-control"
                                            pcgNumeric
                                            required
                                            maxlength="7"
                                        />
                                    }
                                    @if (!canEdit) {
                                        <span class="count">{{ o.onHand }}</span>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            <div class="d-flex justify-content-center">
                @if (canEdit) {
                    <button type="submit" class="btn btn-save btn-lg">Save</button>
                }
            </div>
        </form>
    </div>
}
